import Spinner from 'react-bootstrap/Spinner'

export default function Loading(props) {
    const size = props.size !== undefined ? props.size : "2"
    return <div className={"loading-wrapper d-flex flex-column" + (props.blur ? " blur" : "") + (props.opaque ? " opaque" : "")}>
        <Spinner animation='border' role='status' style={{ width: `${size}rem`, height: `${size}rem` }}>
            <span className='visually-hidden'>Loading...</span>
        </Spinner>
    </div>;
}